// extracted by mini-css-extract-plugin
export var subtitle = "_d2-2";
export var title = "_d2-0";
export var titleNoWrap = "_d2-1";